import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CookiePreferences from '../../Components/ClientDashboard/auth/CookiePreferences';
import OtpScreen from '../../Components/ClientDashboard/auth/OtpScreen';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/client/client_assets/css/LoginPage.css';
import '../../../src/pages/client/client_assets/css/common.css'
import Logo from '../../../src/pages/client/client_assets/img/logo.svg'; 
import NewInviteForm from '../../Components/ClientDashboard/ClientAuth/NewInviteForm';
import HideText from '../../Components/ClientDashboard/Clientcommon/HidePageText';
import left_img from '../../../src/pages/client/client_assets/img/left_img.svg'; 
import { CopyrightContext } from '../../Components/CopyrightContext';

const NewInviteFormPage = () => {

    const year = useContext(CopyrightContext)

    const navigate = useNavigate();
    const location = useLocation();

    const [showModal, setShowModal] = useState(false);
    const [isOtpScreen, setIsOtpScreen] = useState(false);

    const toggleModal = () => {
        setShowModal(!showModal);
    };

    const handleLogin = () => 
    {
        // setIsOtpScreen(true);
    };

    const handleBackToLogin = () => {
        setIsOtpScreen(false);
        navigate('/'); 
    };

    return (
        <div className="login-page">
                    {/* <div className='front_login'> */}
                        <div className="login-left">
                            <div className="glass-layer glass-top">
                                <img src={Logo} alt="Logo" className="logo" />
                            </div>
                            <div className='left_img'>
                                <img src={left_img} alt='brew_left' />
                            </div>

                            <div className="glass-layer glass-bottom">
                                <span className="cookie-preferences" 
                                // onClick={toggleModal}
                                >
                                © {year} Brew Your Brand.
                                </span>
                            </div>
                        </div>
                        <div className="login-right">
                            <div className="login-form-container">
                                {isOtpScreen ? (
                                    <OtpScreen onBack={handleBackToLogin} />
                                ) : (
                                    <NewInviteForm onLogin={handleLogin} />
                                )}
                            </div>
                        </div>
                        {/* <CookiePreferences showModal={showModal} toggleModal={toggleModal} /> */}
                    {/* </div> */}

                    <HideText/>
        </div>
    );
};

export default NewInviteFormPage;
